/**
 * Course List JavaScript Entry
 */

require('../bootstrap');
window.Vue = require('vue');
window.mediaRoot = `https://media.goodschool.hk`;

var VueCookie = require('vue-cookie');
Vue.use(VueCookie);

window.moment = require('moment');
window.CryptoJS = require('crypto-js');
window.CryptoJSAesJson = require('../secret/aes-json-format.js');
if (!CryptoJS) {
    alert("not support cryptojs");
}

window.Popper = require('popper.js').default;
try {
    window.$ = window.jQuery = require('jquery');
    require('bootstrap3');
    require('@fortawesome/fontawesome-free');
} catch (e) {}

import vSelect from 'vue-select'
Vue.component('v-select', vSelect);

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);

Vue.component('course-list-page', require('./CourseList'));

const app = new Vue({
    el: '#app'
});



// WEBPACK FOOTER //
// ./resources/js/course_new/course-list.js